$(document).ready(function () {
    var move_form_add = function (target, id, setfocus) {
        form_refresh()
        var $comment_form = $('.js-comment-form')
        $comment_form.find('input[name=parent]').val(id)
        var $textarea = $comment_form.show().insertAfter(target).find('[name=text]').val('')
        if (setfocus) {
            $textarea.focus()
        }
    }

    var form_refresh = function (empty) {
        //comment form submit refresh
        var $form = $('.js-comment-form')
        $form.find('.errormsg').remove()
        $form.find('.error').removeClass('error')
        $form.find('.wa-captcha-refresh').click()

        if (empty) {
            $form.find('textarea').val('')
        }
    }

    $(document).on('click', '.js-comment-reply', function (e) {
        e.preventDefault()
        // reply to a comment
        var $item = $(this).parents('.js-comment')
        move_form_add($(this).parent(), $item.data('comment-id'), true)
        $('.js-comment').removeClass('comment__in-reply-to')
        $item.addClass('comment__in-reply-to')
    })

    $(document).on('click', '.comment-form input:submit', function (e) {
        e.preventDefault()
        //save comment
        var $button = $(this)
        //Show loader
        $button.attr('disabled', true).next().show()

        var $container = $('.js-comment-form')
        var $form = $('.js-comment-form form')
        $.ajax({
            url: $form.attr('action') + '?json=1',
            data: $form.serialize(),
            type: 'post',
            dataType: 'json'
        }).done(function (response) {
            //Hide loader
            $button.attr('disabled', false).next().hide()

            if (response.status && response.status === 'ok' && response.data.redirect) {
                window.location.replace(response.data.redirect)
                window.location.href = response.data.redirect
            }
            if (response.status && response.status === 'ok' && response.data) {
                // saved
                var $template = $(response.data.template)
                var count_str = response.data.count_str

                var $target
                if ($container.prev().is('.comments')) {
                    $target = $container.prev('.comments').children('ul')
                }
                else {
                    $target = $container.parent()
                    if (!$target.next('ul').length) {
                        $target.after('<ul></ul>')
                    }
                    $target = $target.next('ul')
                }

                $target.append($('<li />').append($template))
                move_form_add('.comments', 0)

                if (response.data.comment_id) {
                    $('#comment-' + response.data.comment_id).addClass('comment__new')
                }

                $('.js-comment').removeClass('comment__in-reply-to')
                $('.js-comment-count').show().html(count_str)

                $template.trigger('plugin.comment_add')
                form_refresh(true)

            }
            else if (response.status && response.status === 'fail') {
                // error
                form_refresh()
                var errors = response.errors
                $(errors).each(function ($name) {
                    var error = this
                    for (name in error) {
                        var $elem = $('.comment-form form').find('[name=' + name + ']')
                        $elem.after($('<em class="errormsg"></em>').text(error[name])).addClass('error')
                    }
                })
            }
            else {
                form_refresh(false)
            }

        }).fail(function () {
            form_refresh(false)
        })
    })
})